<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.managers', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form  @reset="onReset" v-if="show">
                    <b-container>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="lastName-group"
                                        :label="$t('message.lastName')"
                                        label-for="lastName"
                                        description=""
                                >
                                    <b-form-input
                                            id="lastName"
                                            v-model="$v.form.user.nom.$model"
                                            :state="$v.form.user.nom.$dirty ? !(errorshasField('nom') || $v.form.user.nom.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('nom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.user.nom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                        {{ getErrorsField('nom') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="firstName-group"
                                        :label="$t('message.firstName')"
                                        label-for="firstName"
                                        description=""
                                >
                                    <b-form-input
                                            id="lastName"
                                            v-model="$v.form.user.prenom.$model"
                                            :state="$v.form.user.prenom.$dirty ? !(errorshasField('prenom') || $v.form.user.prenom.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('prenom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.user.prenom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('prenom')">
                                        {{ getErrorsField('prenom') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="telephone-group"
                                        :label="$t('message.phoneNumber')"
                                        label-for="telephone"
                                >
                                    <b-form-input
                                            id="telephone"
                                            v-model="$v.form.user.telephone.$model"
                                            :state="$v.form.user.telephone.$dirty ? !(errorshasField('telephone') || $v.form.user.telephone.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('telephone')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.user.telephone.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.user.telephone.integer">
                                        {{ $t('message.integer', { n: 9 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="!$v.form.user.telephone.minLength">
                                        {{ $t('message.minCharacters', { n: 9 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('telephone')">
                                        {{ getErrorsField('telephone') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="email-group"
                                        :label="$t('message.email')"
                                        label-for="email"
                                >
                                    <b-form-input
                                            id="email"
                                            v-model="$v.form.user.email.$model"
                                            :state="$v.form.user.email.$dirty ? !(errorshasField('email') || $v.form.user.email.$error) : null"
                                            type="email"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('email')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.user.email.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.email.email">
                                        {{ $t('message.emailNotValid') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                        {{ getErrorsField('email') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="civility-group"
                                        :label="$t('message.civility')"
                                        label-for="civility">
                                    <b-form-select
                                            id="civility"
                                            v-model="$v.form.civilite.$model"
                                            :state="$v.form.civilite.$dirty ? !(errorshasField('civilite') || $v.form.civilite.$error) : null"
                                            :options="civilites"
                                            required
                                            @focus="clearErrorField('civilite')"
                                    ></b-form-select>

                                    <b-form-invalid-feedback v-if="!$v.form.civilite.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('civilite')">
                                        {{ getErrorsField('civilite') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">
                                <b-form-group
                                        id="nationalite-group"
                                        :label="$t('message.nationality')"
                                        label-for="nationalite"
                                >
                                    <b-form-input
                                            id="nationalite"
                                            v-model="form.user.nationalite"
                                            :state="$v.form.user.nationalite.$dirty ? !(errorshasField('nationalite') || $v.form.user.nationalite.$error) : null"
                                            @focus="clearErrorField('nationalite')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('nationalite')">
                                        {{ getErrorsField('nationalite') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.nationalite.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="singleEditManager-group"
                                        :label="$t('message.select')+' '+$tc('message.countries', 1)"
                                        label-for="singleEditManager">
                                    <!-- Options -->
                                    <select id="singleEditManager"  v-model="form.user.pays" required
                                            class="form-control is-invalid retirerBordure"
                                    >
                                        <option v-for="item in mCountries" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="errorshasField('pays')">
                                        {{ getErrorsField('pays') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.user.pays.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="ville-group"
                                        :label="$tc('message.cities', 1)"
                                        label-for="ville"
                                >
                                    <b-form-input
                                            id="ville"
                                            v-model="form.user.ville"
                                            :state="$v.form.user.ville.$dirty ? !(errorshasField('ville') || $v.form.user.ville.$error) : null"
                                            @focus="clearErrorField('ville')"
                                            required
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('ville')">
                                        {{ getErrorsField('ville') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.ville.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="street-group"
                                        :label="$t('message.street')"
                                        label-for="street"
                                >
                                    <b-form-input
                                            id="street"
                                            v-model="form.user.quartier"
                                            :state="$v.form.user.quartier.$dirty ? !(errorshasField('quartier') || $v.form.user.quartier.$error) : null"
                                            @focus="clearErrorField('quartier')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('quartier')">
                                        {{ getErrorsField('quartier') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="zipCode-group"
                                        :label="$t('message.zipCode')"
                                        label-for="zipCode"
                                >
                                    <b-form-input
                                            id="zipCode"
                                            v-model="form.user.code_postal"
                                            :state="$v.form.user.code_postal.$dirty ? !(errorshasField('code_postal') || $v.form.user.code_postal.$error) : null"
                                            @focus="clearErrorField('code_postal')"
                                            type="number"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('code_postal')">
                                        {{ getErrorsField('code_postal') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="address-group"
                                        :label="$t('message.address')"
                                        label-for="address"
                                >
                                    <b-form-input
                                            id="address"
                                            v-model="form.user.adresse"
                                            :state="$v.form.user.adresse.$dirty ? !(errorshasField('adresse') || $v.form.user.adresse.$error) : null"
                                            @focus="clearErrorField('adresse')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('adresse')">
                                        {{ getErrorsField('adresse') }}
                                    </b-form-invalid-feedback>

<!--                                    <b-form-invalid-feedback v-else-if="!$v.form.user.adresse.required">-->
<!--                                        {{ $t('message.requiredField') }}-->
<!--                                    </b-form-invalid-feedback>-->
                                </b-form-group>

                            </b-col>

                        </b-row>

                    </b-container>
                    <b-row class="justify-content-sm-center" v-if="form.isAuthor || hasAdminRole">
                        <b-button @click="onSubmit" variant="primary">
                            {{ $t('message.edit') }}
                        </b-button>

                        <!--                        <b-button type="reset" variant="danger">-->
                        <!--                            {{ $t('message.reset') }}-->
                        <!--                        </b-button>-->
                    </b-row>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, email,integer, minLength } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';

    export default {
        name: "EditManager",

        computed: {
            ...mapGetters(["manager", "countries", "errors", 'hasAdminRole',
                'hasGestionnaireRole']),
            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            form: function() {
                return this.manager;
            },

            mCountries: function() {
                let cArray = [];

                _.forOwn(this.countries, function(value, key) {
                    cArray.push({ text: value.name, value: value.name });
                });

                return cArray;
            }
        },

        data() {
            return {
                manager_id: this.$route.params.manager,
                show: true,
                civilites: [
                    { value: 'Mme/Mlle.', text: 'Mme/Mlle.' },
                    { value: 'M.', text: 'M.' },
                    { value: 'Dr.', text: 'Dr.' },
                    { value: 'Pr.', text: 'Pr.' }
                ]
            }
        },

        methods: {
            getManager: function() {
                let args = {
                    manager: this.manager_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getManager', { args, errorMessages });
            },

            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        manager: this.manager_id,
                        nom: this.form.user.nom,
                        prenom: this.form.user.prenom,
                        email: this.form.user.email,
                        telephone: this.form.user.telephone,
                        civilite: this.form.civilite,
                        nationalite: this.form.user.nationalite,
                        ville: this.form.user.ville,
                        adresse: this.form.user.adresse,
                        pays: this.form.user.pays,
                        quartier: this.form.user.quartier,
                        code_postal: this.form.user.code_postal
                    };

                    let successMessage = this.$i18n.t('message.managerUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateManager', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                //
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                user: {
                    nom: {
                        required
                    },
                   prenom: {
                        //
                    },
                    telephone: {
                        required,
                        integer,
                        minLength: minLength(9)
                    },
                    email: {
                        required,
                        email
                    },
                    nationalite: {
                        required
                    },
                    ville: {
                        required
                    },
                    quartier: {
                        //
                    },
                    code_postal: {
                        //
                    },
                    pays: {
                        required
                    },
                    adresse: {
                        // required
                    }
                },
                civilite: {
                    required
                }
            }
        },

        mounted() {
            // Retrieve manager
            this.getManager();

            // Retrieve list of countries
            this.getCountries();

            new SlimSelect({
                select: '#singleEditManager',
                placeholder: 'Select Country'
            })
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>